import {
    IBankInfoRequestType,
    IDownloadContractParamsType,
    IEmailExistingParams, IEmployeeCodeParams, IGetEmployeePasswordRequestType,
    IRequestType, ISlackRequestType, IUpdateEmployeeStatustype, IUpdateNotificationStatusRequestType
} from "./type"
const employeeBaseUrl = '/employee'
const notificationBaseUrl = '/notification'
export const EmployeeEndpointConst = {
    employeeList: `${employeeBaseUrl}/list`,
    addBasicInfo: `${employeeBaseUrl}/basic-information`,
    addJobInfo: `${employeeBaseUrl}/job-information`,
    addContactInfo: `${employeeBaseUrl}/contact-information`,
    addBankInfo: `${employeeBaseUrl}/bank-information`,
    addTANInfo: `${employeeBaseUrl}/tan-information`,
    addSecurityInfo: `${employeeBaseUrl}/security-information`,
    addDocumentInfo: `/document`,
    deleteDocumentInfo: `/document`,
    departureEmployeeList: `${employeeBaseUrl}/exit-process/list`,
    departureEmployeeStatus:`${employeeBaseUrl}/exit-process/status`,
    departureEmployeeProcess:`${employeeBaseUrl}/exit-process`,
    getNotificationListUrl: `${notificationBaseUrl}/list`,
    updateContractStatus: `${employeeBaseUrl}/contract/update/status`
}
export const getEmployeeByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.employeeId}/details`
}
export const deleteEmployeeByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.employeeId}`
}
export const getBasicInfoByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.employeeId}/basic-information`
}
export const getJobInfoByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.employeeId}/job-information`
}
export const getContactInfoByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.employeeId}/contact-information`
}
export const getBankInfoByIdUrl = (params: IBankInfoRequestType) => {
    return `${employeeBaseUrl}/${params.employeeCode}/bank-information`
}
export const getTANInfoByIdUrl = (params: IBankInfoRequestType) => {
    return `${employeeBaseUrl}/${params.employeeCode}/tan-information`
}
export const getSecurityInfoByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.employeeId}/security-information`
}
export const getIncapacitateStatusByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.employeeId}/incapacitate/${params.status}`
}
export const getDocumentInfoByIdUrl = (params: IRequestType) => {
    return `/document/${params.employeeId}`
}
export const updateEmployeeStatusUrl = (userReq: IUpdateEmployeeStatustype) => {
    return `${employeeBaseUrl}/${userReq.employeeId}/status/${userReq.status}`
}
export const getEmployeePasswordUrl = (userReq: IGetEmployeePasswordRequestType) => {
    return `${employeeBaseUrl}/${userReq.employeeId}/reveal-password`
}
export const checkEmailExistingUrl = (emailExistingParams: IEmailExistingParams) => {
    return `/auth/validate-existing-useremail?userEmail=${emailExistingParams.email}`
}
export const checkEmployeeCodeExistingUrl = (emailExistingParams: IEmployeeCodeParams) => {
    return `${employeeBaseUrl}/${emailExistingParams.employeeCode}/exists`
}
export const downloadContractUrl = (params: IDownloadContractParamsType) => {
    return `/document/${params.employeeId}/contracts`
}
export const getSlackSyncUrl = (params: ISlackRequestType) => {
    return `${notificationBaseUrl}/slack/sync?employeeEmail=${params.employeeEmail}`;
}
export const updateNotificationUrl = (params: IUpdateNotificationStatusRequestType) => {
    return `${notificationBaseUrl}/status?readAll=${params.readAll}`;
}
export const getExitNotesUrl = (params: IEmployeeCodeParams) => {
    return `${employeeBaseUrl}/exit-process/${params.employeeCode}`
}